import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["append", "prepend", "className", "color", "invalid", "label", "placeholderColor", "prependColor", "style", "theme", "underlineColor", "weight", "namespace", "type"];
import React from 'react';
import InputMask from 'react-input-mask';
import classNames from 'classnames/bind';
import { colors, placeholderColors, prependColors, themes, underlineColors } from "./constants";
import { getMethodsForTestId } from "../utils/getMethodsForTestId";
import styles from './UnderlinedField.css';
var cx = classNames.bind(styles);

var UnderlinedField = function UnderlinedField(_ref) {
  var append = _ref.append,
      prepend = _ref.prepend,
      className = _ref.className,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? colors[1] : _ref$color,
      invalid = _ref.invalid,
      label = _ref.label,
      _ref$placeholderColor = _ref.placeholderColor,
      placeholderColor = _ref$placeholderColor === void 0 ? placeholderColors[1] : _ref$placeholderColor,
      _ref$prependColor = _ref.prependColor,
      prependColor = _ref$prependColor === void 0 ? prependColors[0] : _ref$prependColor,
      style = _ref.style,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? themes[0] : _ref$theme,
      _ref$underlineColor = _ref.underlineColor,
      underlineColor = _ref$underlineColor === void 0 ? underlineColors[1] : _ref$underlineColor,
      weight = _ref.weight,
      namespace = _ref.namespace,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'text' : _ref$type,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _getMethodsForTestId = getMethodsForTestId(namespace, 'underlinedField'),
      getTestId = _getMethodsForTestId.getTestId;

  var Component = rest.mask ? InputMask : 'input';
  return /*#__PURE__*/React.createElement("div", _extends({}, getTestId(), {
    className: cx('UnderlinedField', "UnderlinedField_color_".concat(color), "UnderlinedField_placeholderColor_".concat(placeholderColor), "UnderlinedField_prependColor_".concat(prependColor), "UnderlinedField_theme_".concat(theme), "UnderlinedField_underlineColor_".concat(underlineColor), "UnderlinedField_weight_".concat(weight), {
      UnderlinedField_invalid: invalid
    }, className),
    style: style
  }), label && /*#__PURE__*/React.createElement("label", {
    htmlFor: rest.id
  }, label), /*#__PURE__*/React.createElement("div", {
    className: cx('InputWrapper')
  }, /*#__PURE__*/React.createElement(Component, _extends({
    className: cx('input')
  }, getTestId('input'), rest)), prepend && /*#__PURE__*/React.createElement("div", {
    className: cx('Prepend')
  }, prepend), append && /*#__PURE__*/React.createElement("div", {
    className: cx('Append')
  }, append), /*#__PURE__*/React.createElement("div", {
    className: cx('Underline')
  })));
};

UnderlinedField.displayName = 'UnderlinedField';
export default UnderlinedField;